import { LoadablePaint } from '@confluence/loadable';

export const FolderRedirectLoader = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-FolderRedirect" */ '../src/FolderRedirect'))
			.FolderRedirect,
});
